import type { DomainHooksRegistryInterface } from "~/context/domain-hooks-context/domain-hooks-registry.interface";


import { useProjectsDashboard } from "~/modules/main/hooks/use-projects-dashboard/use-projects-dashboard";

import { useProjectWorkspace } from "~/modules/main/hooks/use-project-workspace/use-project-workspace";

import { useTaskDetails } from "~/modules/main/hooks/use-task-details/use-task-details";


/**
 * Domain hook implementations
 * 
 * This is a collection of all the domain hooks that are available in the application.
 * It is used to provide the domain hooks to the application.
 * 
 * You can access them by using the `useDomainHooks` hook.
 */
export const domainHooksRegistry: DomainHooksRegistryInterface = {

    useProjectsDashboard: useProjectsDashboard,

    useProjectWorkspace: useProjectWorkspace,

    useTaskDetails: useTaskDetails,

} as DomainHooksRegistryInterface;